const src = import.meta.ROLLUP_FILE_URL_tgFyw$X211zXSctfMU9_LA;
export default {
  src,
  srcSet: src + " " + 1322 + "w",
  width: 1322,
  height: 892,
};